import React, { useState } from 'react'
import styled from 'styled-components'
import AccordionCard, { AccordionCardRow } from 'core-system/AccordionCard'
import Text from 'core-system/Text'
import FlexContainer from 'core-system/FlexContainer'

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0.5rem 1rem 0.5rem 0;
  gap: 1rem;
`

const HeaderCopy = styled.div`
  flex: 1;
`

const Body = styled.div`
  width: 100%;
  padding: 1.5rem 1.5rem 1.25rem;
`

export interface SyncSettingsCollapsibleProps {
  title: string
  status: string
  children: React.ReactNode
}

const SyncSettingsCollapsible: React.FC<SyncSettingsCollapsibleProps> = ({
  title,
  status,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <AccordionCard
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      marginBottom='1.5rem'
    >
      <AccordionCardRow
        minHeight='4.5rem'
        allowHoverEffect={false}
        data-testid={`sync-settings-header-${title}`}
      >
        <Header>
          <HeaderCopy>
            <Text variant='action3'>{title}</Text>
          </HeaderCopy>
          <FlexContainer>
            <Text variant='body2' color='grey600'>
              {status}
            </Text>
          </FlexContainer>
        </Header>
      </AccordionCardRow>
      <AccordionCardRow
        allowHoverEffect={false}
        openMaxHeight='none'
        data-testid={`sync-settings-body-${title}`}
      >
        <Body>{children}</Body>
      </AccordionCardRow>
    </AccordionCard>
  )
}

export default React.memo(SyncSettingsCollapsible)
